import { request } from './client.js';

export const api = {
  // Auth
  authTelegram: (initData) => request('POST', '/v1/auth/telegram', { body: { initData } }),
  authDev: (telegramId, username, firstName) =>
    request('POST', '/v1/auth/dev', { body: { telegram_id: telegramId, username, first_name: firstName } }),

  // User
  getMe: () => request('GET', '/v1/users/me'),

  // Packs
  listPacks: () => request('GET', '/v1/packs'),
  getPack: (id) => request('GET', `/v1/packs/${id}`),

  // Sessions (Phase 1 v2)
  getCurrentSession: () => request('GET', '/v1/sessions/current'),
  startSession: (packId) => request('POST', '/v1/sessions', { body: { pack_id: packId } }),
  unlockMilestone: (sessionId, milestone) =>
    request('POST', `/v1/sessions/${sessionId}/unlock`, { body: { milestone } }),
  sessionDie: (sessionId) => request('POST', `/v1/sessions/${sessionId}/die`),
  sessionRespawn: (sessionId) => request('POST', `/v1/sessions/${sessionId}/respawn`),
  sessionEnd: (sessionId, score = 0) =>
    request('POST', `/v1/sessions/${sessionId}/end`, { body: { score } }),

  // Topup (Telegram Stars 1:1)
  createStarInvoice: (amount) =>
    request('POST', '/v1/topup/star/invoice', { body: { amount } }),

  // Leaderboard + Referral + Airdrop
  getLeaderboard: () => request('GET', '/v1/leaderboard'),
  getReferralInfo: () => request('GET', '/v1/referrals/me'),
  getAirdropInfo: () => request('GET', '/v1/airdrop/me')
};
